__turbopack_context__.v({
  "avatar": "TGuqeq_avatar",
  "avatarImg": "TGuqeq_avatarImg",
  "badge": "TGuqeq_badge",
  "badgeActive": "TGuqeq_badgeActive",
  "badgeArchived": "TGuqeq_badgeArchived",
  "badgeCompleted": "TGuqeq_badgeCompleted",
  "badgeDefault": "TGuqeq_badgeDefault",
  "badgeRegistrationOpen": "TGuqeq_badgeRegistrationOpen",
  "badgeText": "TGuqeq_badgeText",
  "badgeUpcoming": "TGuqeq_badgeUpcoming",
  "card": "TGuqeq_card",
  "cardContent": "TGuqeq_cardContent",
  "completed": "TGuqeq_completed",
  "date": "TGuqeq_date",
  "dateText": "TGuqeq_dateText",
  "description": "TGuqeq_description",
  "highlighted": "TGuqeq_highlighted",
  "moreButton": "TGuqeq_moreButton",
  "nonClickable": "TGuqeq_nonClickable",
  "overline": "TGuqeq_overline",
  "textBlock": "TGuqeq_textBlock",
  "title": "TGuqeq_title",
});
